<script setup>
  import { computed } from "vue";
  import { useFormattedText } from "@/utils/composables/useFormattedText";

  const props = defineProps({
    element: {
      type: Object,
      required: true,
    },
    bindings: {
      type: Object,
      default: () => ({}),
    },
    textStyleOverride: {
      type: Object,
      default: null,
    },
  });

  const { getFormattedTextContent, buildStyleObject } = useFormattedText();

  const ANCHOR_TO_JUSTIFY = { t: "flex-start", ctr: "center", b: "flex-end" };

  const containerStyle = computed(() => {
    const anchor = props.element.text_vertical_align || "t";
    return { justifyContent: ANCHOR_TO_JUSTIFY[anchor] ?? "flex-start" };
  });

  const textStyle = computed(() => buildStyleObject(props.textStyleOverride ?? props.element.text_style ?? {}));

  const formattedContent = computed(() => getFormattedTextContent(props.bindings[props.element.name]?.value || ""));
</script>

<template>
  <div
    class="w-full h-full p-2 formatted-text flex flex-col"
    :style="containerStyle">
    <div
      :style="textStyle"
      v-html="formattedContent" />
  </div>
</template>

<style scoped>
  .formatted-text :deep(strong),
  .formatted-text :deep(b) {
    font-weight: 700;
  }

  .formatted-text :deep(em),
  .formatted-text :deep(i) {
    font-style: italic;
  }

  .formatted-text :deep(p) {
    margin: 0;
  }

  .formatted-text :deep(ul) {
    margin: 0;
    padding-left: 1.2em;
    list-style-type: disc;
  }

  .formatted-text :deep(li) {
    margin: 0;
  }
</style>
